.body {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

/* ── Спарклайн ────────────────────────────────────────────────────────────
   Форма, а не график: осей и подписей у него нет, цифры под ним говорят,
   между какими ценами нарисована линия. */
.sparkWrap {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  padding: var(--sp-4);
  background: var(--surface-2);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
}

.spark {
  display: block;
  width: 100%;
  height: 44px;
  color: var(--flight);
}

.sparkScale {
  display: flex;
  justify-content: space-between;
  color: var(--text-3);
  font-size: var(--fs-xs);
}

.empty {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

/* Запись в историю не удалась. Цена при этом в блок уже поставлена, поэтому
   тон предупреждающий, а не аварийный: сломалась отметка, а не действие. */
.error {
  margin: 0;
  padding: var(--sp-2) var(--sp-4);
  background: var(--warn-bg);
  border: var(--bw) solid var(--warn-border);
  border-radius: var(--radius);
  color: var(--warn);
  font-size: var(--fs-sm);
}

.rows {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

.row {
  padding-bottom: var(--sp-4);
  /* Разделитель между блоками — всегда волосок, при любой теме. */
  border-bottom: 1px solid var(--border);
}

.row:last-child {
  padding-bottom: 0;
  border-bottom: none;
}

.head {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: var(--sp-2) var(--sp-4);
  min-width: 0;
}

/* В подписи проверки стоит штамп времени — цифры табличные, иначе соседние
   строки списка не выстраиваются в столбик. */
.kind {
  font-weight: 600;
  font-size: var(--fs-sm);
  font-variant-numeric: tabular-nums;
}

.stamp {
  color: var(--text-3);
  font-size: var(--fs-xs);
}

.best {
  margin-left: auto;
  font-size: var(--fs-md);
  font-weight: 600;
}

.site {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text-2);
  font-size: var(--fs-sm);
}

/* Отказ и «не нашли» — такая же часть истории, как найденная цена:
   молчащая строка выглядит поломкой, а не результатом. */
.note {
  margin: var(--sp-2) 0 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.quotes {
  margin-top: var(--sp-3);
}

.summary {
  cursor: pointer;
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.quoteList {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  margin: var(--sp-3) 0 0;
  padding: 0;
  list-style: none;
}

.quote {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--sp-2) var(--sp-3);
  min-width: 0;
}

.qSite {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--fs-sm);
}

a.qSite {
  color: var(--flight);
}

.qPrice {
  flex: 0 0 auto;
  font-size: var(--fs-sm);
  font-weight: 600;
}

/* Совпадение по перевозчику, номеру и дате — единственное, что делает цену
   сравнимой. Отметка приглушённая: это норма, а не награда. */
.exact {
  flex: 0 0 auto;
  padding: 0 var(--sp-2);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  background: var(--surface-2);
  color: var(--text-3);
  font-size: var(--fs-xs);
}

.qNote {
  flex: 1 1 100%;
  color: var(--text-3);
  font-size: var(--fs-xs);
}

.applyBtn {
  flex: 0 0 auto;
  padding: var(--sp-1) var(--sp-3);
  font-size: var(--fs-xs);
}

/* ── Мобильный вид (порог продублирован в ui/shell/useIsMobile.ts) ──────── */
@media (max-width: 720px) {
  /* Цена перестаёт прижиматься к правому краю: в две-три строки шапки это
     выглядело бы случайным отступом. */
  .best {
    margin-left: 0;
  }

  .applyBtn {
    width: 100%;
    height: 32px;
  }
}
